/* eslint-disable @typescript-eslint/no-explicit-any */
import type { IAllowance } from './wallet';

export enum PaymentSourceEnum {
  SALARY = 'SALARY',
  ALLOWANCE = 'ALLOWANCE',
  SALARY_ALLOWANCE = 'SALARY_ALLOWANCE',
  SALARY_OR_ALLOWANCE = 'SALARY_OR_ALLOWANCE',
  ALLOWANCE_THEN_SALARY = 'ALLOWANCE_THEN_SALARY',
}

export enum DefaultDeductionSourceEnum {
  ALLOWANCE_FIRST = 'ALLOWANCE_FIRST',
  SALARY_FIRST = 'SALARY_FIRST',
}

export enum BenefitTypeEnum {
  MODULAR = 'MODULAR',
}

export interface IProgramme {
  id: number;
  frequency: string;
  allowance: IAllowance;
}

export interface IPrimaryAddonsBreakdown {
  employee_price: string;
  key: string;
  price: string;
}

export interface IAddon {
  id: number;
  is_missing_requirement: boolean;
  name: string;
  name_en: string;
  name_de: string;
  description: string;
  description_en: string;
  description_de: string;
  url: string;
  price_per_month_currency: string;
  price_per_month: string;
  price_per_year_currency: string;
  price_per_year: string;
  price_key: string;
  requirement: string[];
  level: string;
  rank: number;
  benefit_paid_by: string;
  employee_contribution: number;
  benefit: number;
}

export interface IBenefit {
  id: number;
  missing_requirements: [];
  benefit_requirements: [];
  pension_config: string;
  additional_config: string;
  supports_beneficiaries: boolean;
  image_url: string;
  programmes: IProgramme[];
  currency: string;
  documents: [];
  name: string;
  name_en: string;
  name_de: string;
  rank: number;
  external_link_url: string;
  discount_text: string;
  discount_text_en: string;
  discount_text_de: string;
  cta_text: string;
  cta_text_en: string;
  cta_text_de: string;
  content: string;
  content_en: string;
  content_de: string;
  active: boolean;
  created_timestamp: string;
  updated_timestamp: string;
  price_per_month_currency: string;
  price_per_month: string;
  price_per_year_currency: string;
  price_per_year: number;
  is_taxable: boolean;
  show_price: boolean;
  enrolment_type: string;
  benefit_paid_by: string;
  employee_contribution: 0;
  tax_paid_by: string;
  short_description: string;
  short_description_en: string;
  short_description_de: string;
  age_calculate_from: string;
  price_calculator: string;
  price_key: string;
  start_date: string;
  renewal_date: string;
  benefit_type: string;
  contact_relation_tooltip: string;
  contact_relation_tooltip_en: string;
  contact_relation_tooltip_de: string;
  tax_info: string;
  tax_info_en: string;
  tax_info_de: string;
  group_membership_number: string;
  auto_activating: boolean;
  deactivate_enrolments_with_programme: boolean;
  payment_source: string;
  deduction_type: string;
  close_opt_in_window_after_opt_out: boolean;
  provider: string;
  employer: number;
  managed_by: number;
  activation_delay: string;
  deactivation_delay: string;
  categories: [];
}

export interface IAttachment {
  file: string;
  name: string;
}

export interface IEmployeeBenefitsList {
  name?: string;
  benefits: IEmployeeBenefitOld[];
}

export interface IEmployeeBenefitOld {
  name: string;
  benefitId: number;
  isActive: boolean;
  status: string;
  rank: number;
  price: string;
  employeeMonthlyPrice: string;
  employerMonthlyPrice: string;
  priceCurrency: string;
  configWindowOpen: boolean;
  enrolmentWindows?: IEnrolmentWindow[];
  programmes?: IProgramme[];
  imageUrl?: string;
  shortDescription?: string;
  id: number;
  pk: number;
  externalLinkUrl?: string;
  discountText?: string;
  ctaText?: string;
  content?: string;
  provider?: string;
  categories?: any[];
  showPrice?: boolean;
  lockedEnrolment?: boolean;
  isEnrolledByDefault?: boolean;
  enrolmentType: string;
  benefitType: string;
  enrolmentStartDate?: string;
  enrolmentEndDate?: string;
  isSelected?: boolean;
  lockedWindowOpen?: boolean;
}

export interface IEnrolmentWindow {
  windowType: string;
  startTimestamp: string;
  endTimestamp: string;
  isOpen: boolean;
}
